import { gql } from '@apollo/client'
import type { UseMutationProps } from '../useMutation'
import { useActionMutation } from '../useMutation'
import type { History } from '@ztechapps/common.contract'

export type SimpleHistoryInput = {
  entityKey: string
  description: string
  meta?: Record<any, any>
}

export type useCreateSimpleHistoryProps = Omit<UseMutationProps, 'query'> & {
  entity: string
}
export const useCreateSimpleHistory = ({ entity, ...props } = {} as unknown as useCreateSimpleHistoryProps) => {
  if (!entity) {
    throw new Error('entity is required')
  }

  const defaultQuery = `mutation create${entity}SimpleHistory($input: HistoryInput!) {
      create${entity}SimpleHistory(input: $input) {
        _id
        entityKey
        description
      }
    }
  `
  const query = gql(defaultQuery)

  const result = useActionMutation<History, SimpleHistoryInput>({
    query,
    ...props,
  })

  return result
}
